import { createAsyncThunk } from '@reduxjs/toolkit'
import { BomItemController } from 'controllers/Project/BomItemController'
import { getContext } from 'store/getContext'
import { newProjectActions } from '../newProjectReducer'
import { fetchProject } from './fetchProject'

export const saveBomItemQuantity = createAsyncThunk<any, any, { state: any }>(
  'boM/saveBomItemQuantity',
  async (
    {
      bomItemId,
      quantity,
    }: {
      bomItemId: string
      quantity: number
      preferTreeView?: boolean
    },
    thunkAPI
  ) => {
    const { partyId: organizationId, projectId } = getContext(thunkAPI.getState)

    thunkAPI.dispatch(
      newProjectActions.setBomItemProperties({
        id: bomItemId,
        financial: {
          quantity: parseInt(quantity.toString()),
        },
      })
    )

    thunkAPI.dispatch(newProjectActions.resetBomItemFinancials([bomItemId]))

    const controller = new BomItemController(organizationId, projectId)

    try {
      await controller.SetBomItemQuantity(bomItemId, quantity)
    } catch (err) {
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw err
    }
  }
)
